import { render, staticRenderFns } from "./ErrorSearch.vue?vue&type=template&id=78f8475e"
import script from "./ErrorSearch.vue?vue&type=script&lang=js"
export * from "./ErrorSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports